import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'dark',
    primary: {
      main: '#1565C0',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#B0BEC5',
      contrastText: '#000000',
    },
    background: {
      default: '#29293D',
      paper: '#3E3E3E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: { fontSize: '26px', fontWeight: 700, lineHeight: '32px', marginBottom: '16px' },
    h2: { fontSize: '22px', fontWeight: 700, lineHeight: '28px', marginBottom: '16px', marginTop: '24px' },
    h3: { fontSize: '20px', fontWeight: 600, lineHeight: '26px' },
    h4: { fontSize: '18px', fontWeight: 600, lineHeight: '24px' },
    body1: { fontSize: '16px', fontWeight: 400, lineHeight: '24px' },
    body2: { fontSize: '15px', fontWeight: 400, lineHeight: '22px', color: 'rgba(255, 255, 255, 0.60)' },
    button: { fontSize: '14px', textTransform: 'none', fontWeight: 500 },
    caption: { fontSize: '14px', lineHeight: '20px' },
    overline: { fontSize: '12px', lineHeight: '16px', letterSpacing: '0.5px', textTransform: 'none' },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.main-button-link': {
          color: 'rgba(255, 255, 255, 0.6)',
          textDecoration: 'none',
          '&:hover': {
            color: '#FFF',
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-root': {
            color: '#B0BEC5',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(176, 190, 197, 0.4)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 700,
        },
        outlined: {
          '&:hover': {
            borderColor: '#B0BEC5',
            backgroundColor: 'rgba(176, 190, 197, 0.1)',
          },
          '&.Mui-focused': {
            borderColor: '#B0BEC5',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(176, 190, 197, 0.2)',
          },
          '&:hover': {
            backgroundColor: 'rgba(176, 190, 197, 0.1)',
          },
          '& .MuiTouchRipple-root': {
            color: '#B0BEC5',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: '#3E3E3E',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
          root: {
            backgroundColor: '#B0BEC5',
            color: '#000',
            fontWeight: 600,
          },
        icon: {
          color: '#000',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'h6',
          subtitle2: 'h6',
          body1: 'p',
          body2: 'span',
          caption: 'span',
          overline: 'span',
          button: 'span',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
          paper: {
            border: '1px solid rgba(176, 190, 197, 0.3)',
          },
      },
    },
  },
});

export default theme;
